import axios from 'axios';
import { Dispatch, useEffect } from 'react';
import { Setting, Subscription } from '../App';
import { CUSTOMER_API_URL } from '../constants';
import { createShippingAddress, ShippingAddressType } from '../types/shipping-address-type';
import dayjs from "dayjs";

export const useShippingAddress = (setting: Setting, setSubscriptionContractId: Dispatch<string>, setShippingAddress: Dispatch<ShippingAddressType>) => {
  useEffect(() => {
    (async () => {
      try {
        const response = await axios.post(
          `${CUSTOMER_API_URL}?action=getSubscriptions`,
          {},
          { headers: { Authorization: setting.token } }
        );

        const subscriptions = response.data.filter((subscription: Subscription) => subscription.status === 'ACTIVE');
        if (subscriptions.length === 0) return;

        const subscription = subscriptions[0] as Subscription;
        setSubscriptionContractId(subscription.subscriptionContractId);
        setShippingAddress(await createShippingAddress(subscription));
      } catch (e) {
        console.log(e);
      }
    })();
  }, [setShippingAddress, setSubscriptionContractId, setting.token]);

  const updateShippingAddress = (subscriptionContractId: string, shippingAddress: ShippingAddressType, success:() => void, failed?: (message: string) => void) => {
    (async () => {
      try {
        await axios.post(
            `${CUSTOMER_API_URL}?action=updateDeliveryAddress`,
            {
              subscriptionId: subscriptionContractId,
              deliveryAddress1: shippingAddress.address1,
              deliveryAddress2: shippingAddress.address2,
              deliveryCity: shippingAddress.city,
              deliveryCompany: shippingAddress.company,
              deliveryCountryCode: shippingAddress.countryCode,
              deliveryFirstName: shippingAddress.firstName,
              deliveryLastName: shippingAddress.lastName,
              deliveryPhone: shippingAddress.phone,
              deliveryProvinceCode: shippingAddress.provinceCode,
              deliveryZip: shippingAddress.zip,
            },
            {
              headers: { Authorization: setting.token },
            }
        );
        success();
      } catch (e) {
        if (failed) {
          failed(e.message);
        }
      }
    })();
  };

  return {
    updateShippingAddress,
  };
};
